import React, { useEffect, useContext } from "react";
import {
	DatePicker, Form, Input, Modal, Select, Tag, Upload, Button, Row, Space, Col,
	notification, Checkbox
} from "antd";
import { useAtom } from "jotai";
import { EditOutlined, CalendarOutlined, CheckOutlined, PlusCircleFilled, MinusCircleFilled, DeleteOutlined } from "@ant-design/icons";
import {
	formularioSolicitarAusenciaAtom,
	visibleModalCrearSolicitudAusenciaAtom,
	visibleModalFirmarSolicitudAusenciaAtom,
	archivosAdjuntosAtom,
	ocultarFechasSolicitadasAtom,
} from "../../store/MisSolicitudesStore";
import {
	useListarTiposAusencia,
	useObtenerAprobadorPrimerNivel,
	useObtenerOtroAprobadorPrimerNivel,
	useObtenerDetalleVacacionesColaborador,
	useObtenerJefeInmediato,
	useSeleccionarTipoAusencia,
	useSimularDescuentoVacaciones,
} from "../../hooks";
import { useDispositivo } from "hooks";
import { useBloqueoMovimientos, AvisoBloqueoMovimientos } from "../../../bloqueo-movimientos";
import Control from "./Control";
import Archivo from "./Archivo";
import { UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import { SecurityContext } from "context/SecurityContextProvider";
import { useState } from "react";
import FormItem from "antd/lib/form/FormItem";
import LoginService from "../../../../../../../services/LoginService";
import ActualizarClaveService from "../../../../../../../services/ActualizarClaveService";
import { PortalColaboradorService } from "services/PortalColaboradorService";
import ColaboradorService from "services/ColaboradorService";
import { SolicitudAusenciaService } from "services";

const ModalCrearSolicitudAusencia = () => {
	const { RangePicker } = DatePicker;
	const { TextArea } = Input;
	const [form] = Form.useForm();
	const fechasSolicitadas = [];
	const [visibleModal, setVisibleModal] = useAtom(visibleModalCrearSolicitudAusenciaAtom);
	const { fechaLimite, fechaMinimaSolicitud, deshabilitarFechaBloqueada, deshabilitarFueraDeVentana } = useBloqueoMovimientos(visibleModal);
	const [, setVisibleModalFirmar] = useAtom(visibleModalFirmarSolicitudAusenciaAtom);
	const [, setFormularioSolicitarAusencia] = useAtom(formularioSolicitarAusenciaAtom);

	const { tipoAusencia, limpiarTipoAusencia, onChangeTipoAusencia, contabilizaHoras, actualizarContabilizarHoras } = useSeleccionarTipoAusencia();
	const { tiposAusencia } = useListarTiposAusencia();
	const { vacacionesSimuladas, vacacionesSimuladasError, descontarDias, limpiarSimulacion } =
		useSimularDescuentoVacaciones();
	const { jefeInmediato } = useObtenerJefeInmediato();
	const { detalleVacacionesColaborador } = useObtenerDetalleVacacionesColaborador();
	const { esMovil, esDesktop } = useDispositivo();
	const { getUsuarioAutenticado } = useContext(SecurityContext);
	const isMaccaferriDePeru = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20418710757" ? true : false;
	const isMaccaferriConstruction = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20521749378" ? true : false;
	const [ocultarFechasSolicitadas, setOcultarFechasSolicitadas] = useAtom(ocultarFechasSolicitadasAtom);
	const [visibleCrearClaveModal, setVisibleCrearClaveModal] = useState(false);
	const [formularioCambiarClave] = Form.useForm();
	const [loadingModalClave, setLoadingModalClave] = useState(false);
	const [existeClave, setExisteClave] = useState(false);
	const { aprobadorPrimerFlujo } = useObtenerAprobadorPrimerNivel();
	const { otroAprobadorPrimerFlujo } = useObtenerOtroAprobadorPrimerNivel();
	const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
	const isManuelita = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20411051782" ? true : false;
	const isDemo = getUsuarioAutenticado().empresaSeleccionada?.ruc === "12345678901" ? true : false;
	const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;
	// Estado local para el checkbox
	const [especificarHora, setEspecificarHora] = useState(false);
	const [colaboradores, setColaboradores] = useState(undefined);
	const [historialCambioGrupo, setHistorialCambioGrupo] = useState([]);
	const [loadingHistorial, setLoadingHistorial] = useState(false);
	const [idsParaEliminar, setIdsParaEliminar] = useState([]);
	const [acumuladoDescansoMedico, setAcumuladoDescansoMedico] = useState(null);
	const [simulacionDescansoMedico, setSimulacionDescansoMedico] = useState(null);
	const [esDescansoMedico, setEsDescansoMedico] = useState(false);

	useEffect(() => {
		const cargarDatos = async () => {
			if (visibleModal) {
				form.resetFields();
				limpiarSimulacion();
				setIdsParaEliminar([]);
			}
		};
		cargarDatos();
	}, [visibleModal]);

	useEffect(() => {
		const cargarAprobador = async () => {
			form.setFieldsValue({
				aprobador: tipoAusencia?.requiereAprobacionJefeInmediato
					? jefeInmediato?.nombreCompleto
					: !tipoAusencia?.requiereAprobacionJefeInmediato && tipoAusencia?.requiereAprobacionOtrosCargos
						? tipoAusencia?.aprobadoresOtrosCargos[0].nombreCompleto
						: tipoAusencia?.permitirAprobacionPrimerFlujo
							? aprobadorPrimerFlujo.nombreCompleto
							: tipoAusencia?.permitirOtroAprobacionPrimerFlujo ? otroAprobadorPrimerFlujo.nombreCompleto : null
			});
		};
		cargarAprobador();
	}, [tipoAusencia]);

	useEffect(() => {
		const cargarValidacion = async () => {
			if (isMaccaferriDePeru || isMaccaferriConstruction) {
				const datos = await PortalColaboradorService.validarExisteClave();
				console.log("datos:::", datos);
				setExisteClave(datos.existeClave);
			}
		};
		cargarValidacion();
	}, [existeClave]);

	const deshabilitarFechasSolicitudFin = (current) => {
		if (tipoAusencia?.contabilizarHoras) {
			return moment(current).format("DD/MM/YYYY") < moment(fechasSolicitadas[0]).format("DD/MM/YYYY");
		}
		return current < fechasSolicitadas[0];
	};
	const deshabilitarFechaSolicitudInicio = (current) => {
		//return current && current < moment().endOf('day');
		return current && current < moment().startOf("day");
	};

	// Un movimiento no puede iniciar en o antes de la fecha limite del bloqueo (aunque el tipo permita fechas anteriores).
	const deshabilitarFechaInicio = (current) =>
		deshabilitarFechaBloqueada(current) ||
		(!tipoAusencia?.permitirSolicitudFechasAnteriores &&
			// Con ventana retroactiva configurada, esta reemplaza a la regla "desde hoy".
			(fechaMinimaSolicitud ? deshabilitarFueraDeVentana(current, false) : !!deshabilitarFechaSolicitudInicio(current)));

	const onClickBtnSolicitar = async (formulario) => {
		if (ocultarFechasSolicitadas) {
			formulario.fechasSolicitud = [];
			if (isSDF || isSDFEnergia) {
				formulario.fechasSolicitud[0] = formulario.informacionAdicional["Fecha-Cambio"] || formulario.informacionAdicional["Por-El-Dia"];
				formulario.fechasSolicitud[1] = formulario.informacionAdicional["Fecha-Cambio"] || formulario.informacionAdicional["Por-El-Dia"];
			} else {
				formulario.fechasSolicitud[0] = formulario.informacionAdicional.diaCompensacion;
				formulario.fechasSolicitud[1] = formulario.informacionAdicional.diaCompensacion;
			}
		}

		if (esMovil && !ocultarFechasSolicitadas && !tipoAusencia?.solicitarUnaFecha) {
			formulario.fechasSolicitud = [];
			formulario.fechasSolicitud[0] = formulario.fechaSolicitudInicio;
			formulario.fechasSolicitud[1] = formulario.fechaSolicitudFin;
		}

		if (tipoAusencia?.solicitarUnaFecha) {
			formulario.fechasSolicitud = [];
			formulario.fechasSolicitud[0] = formulario.fechaEfectiva;
			formulario.fechasSolicitud[1] = formulario.fechaEfectiva;
		}

		if (tipoAusencia?.descripcion?.toLowerCase() === "cambio de grupo") {
			const primeraFecha = formulario.informacionAdicional?.cambioGrupo?.[0]?.fecha;
			formulario.fechasSolicitud = [primeraFecha ?? null, primeraFecha ?? null];
		}
		//console.log("formulario", formulario);

		// console.log("keys", Object.keys(formulario.adjuntos));
		// console.log("values", Object.values(formulario.adjuntos));

		// var adjuntos = [];
		// for (var posicion = 0; posicion < Object.keys(formulario.adjuntos).length; posicion++) {
		// 	adjuntos[posicion] = Object.values(formulario.adjuntos)[posicion].file;
		// }
		// console.log("adjuntos", adjuntos);

		// const adjuntos = formulario.adjuntos.map((adjunto) => {
		// 	return adjunto.file;
		// });
		// console.log("adjuntos", adjuntos);

		formulario.historialCambioGrupoEliminar = idsParaEliminar;
		setFormularioSolicitarAusencia(formulario);
		setVisibleModalFirmar(true);
	};

	const onChangeDatePickerFechaInicio = (fecha) => {
		fechasSolicitadas[0] = fecha;
	};

	const onChangeDatePickerFechaFin = async (fecha) => {
		fechasSolicitadas[1] = fecha;
		descontarDias(fechasSolicitadas);
		if ((isSDF || isSDFEnergia) && esDescansoMedico && fechasSolicitadas[0] && fechasSolicitadas[1]) {
			const diasSolicitados = fechasSolicitadas[1].diff(fechasSolicitadas[0], "days") + 1;
			try {
				const response = await SolicitudAusenciaService.simularDescansoMedico(diasSolicitados);
				if (response.estado === "EXITO") {
					setSimulacionDescansoMedico(response.data);
				}
			} catch (error) {
				console.error("Error al simular DM:", error);
			}
		}
	};

	const onChangeRangePicker = async (fechas) => {
		descontarDias(fechas);
		if ((isSDF || isSDFEnergia) && esDescansoMedico && fechas && fechas[0] && fechas[1]) {
			const diasSolicitados = fechas[1].diff(fechas[0], "days") + 1;
			try {
				const response = await SolicitudAusenciaService.simularDescansoMedico(diasSolicitados);
				if (response.estado === "EXITO") {
					setSimulacionDescansoMedico(response.data);
				}
			} catch (error) {
				console.error("Error al simular DM:", error);
			}
		} else {
			setSimulacionDescansoMedico(null);
		}
	};

	const FechasSolicitadasExtra = () => {
		if (tipoAusencia?.contabilizarDiasVacaciones) {
			if (vacacionesSimuladas) {
				return (
					<React.Fragment>
						<div
							style={{
								marginTop: "5px",
								display: "flex",
								justifyContent: "space-between",
							}}
						>
							<Tag color="warning">
								<EditOutlined /> Se descontarán de su saldo:
								<span style={{ padding: "0px", fontWeight: "bold" }}>
									{vacacionesSimuladas.diasSolicitados}
								</span>{" "}
								días
							</Tag>
						</div>
						<div style={{ marginTop: "5px" }}>
							<Tag color="blue">
								<CalendarOutlined /> Periodo Vacacional:{" "}
								<span style={{ fontWeight: "bold" }}>
									{(isSDF || isSDFEnergia)
										? vacacionesSimuladas.periodoVacacionalInicio.substring(6)
										: vacacionesSimuladas.periodoVacacionalInicio}
								</span>{" "}
								{" - "}
								<span style={{ fontWeight: "bold" }}>
									{(isSDF || isSDFEnergia)
										? vacacionesSimuladas.periodoVacacionalFin.substring(6)
										: vacacionesSimuladas.periodoVacacionalFin}
								</span>
							</Tag>
						</div>
					</React.Fragment>
				);
			}
			if (vacacionesSimuladasError) {
				return (
					<div
						style={{
							marginTop: "5px",
							display: "flex",
							justifyContent: "space-between",
						}}
					>
						<Tag color="error">
							<span style={{ padding: "0px", fontWeight: "bold" }}>{vacacionesSimuladasError}</span>
						</Tag>
					</div>
				);
			}
		}
		return "";
	};

	// Funciones para abrir y cerrar el modal para crear clave
	const abrirCrearClaveModal = () => setVisibleCrearClaveModal(true);
	const cerrarCrearClaveModal = () => setVisibleCrearClaveModal(false);

	async function handleOnFinish(formulario) {
		console.log("formularioooo:::", formulario);
		try {
			setLoadingModalClave(true);
			const mensajeValidacion = await ActualizarClaveService.crearClave(
				LoginService.getUsuarioAutenticado().subdominio,
				getUsuarioAutenticado().numeroDocumentoIdentidad,
				formulario.clave
			);
			console.log("mensajeValidacion::", mensajeValidacion);
			let mensaje = (mensajeValidacion != null && mensajeValidacion != "") ? mensajeValidacion.message : null;
			//setMensajeError(mensaje);
			setLoadingModalClave(false);
			if (mensaje == null || mensaje == "") {
				setExisteClave(true);
				notification.success({
					message: "Operación exitosa",
					description: "Se actualizo su clave.",
				});
				setVisibleCrearClaveModal(false)
			}

		} catch (error) {
			console.log(error);
			setLoadingModalClave(false);
			notification.error({
				message: "No se puede guardar la clave",
				description: "Error al generar la clave",
			});
		}
	}

	// Handler para el checkbox
	const handleEspecificarHoraChange = (e) => {
		const checked = e.target.checked;
		setEspecificarHora(checked);

		// Actualizar tipoAusencia.contabilizarHoras
		actualizarContabilizarHoras(checked);

		// Si se desmarca, limpiar los valores de hora
		if (!checked) {
			form.setFieldsValue({
				fechasSolicitud: null,
				// fechaSolicitudInicio: null,
				// fechaSolicitudFin: null,
				// fechaEfectiva: null
			});
		}
	}

	useEffect(() => {
		if (tipoAusencia?.descripcion?.toLowerCase() !== "cambio de grupo") {
			setHistorialCambioGrupo([]);
			setIdsParaEliminar([]);
		}
	}, [tipoAusencia]);

	useEffect(() => {
		const cargarAcumuladoDM = async () => {
			const esDescansoMedicoTipo =
				tipoAusencia?.descripcion?.toLowerCase().includes("descanso m") ||
				tipoAusencia?.nombre?.toLowerCase().includes("descanso m");

			setEsDescansoMedico(esDescansoMedicoTipo);

			if ((isSDF || isSDFEnergia) && esDescansoMedicoTipo) {
				try {
					const response = await SolicitudAusenciaService.obtenerAcumuladoDescansoMedico();
					if (response.estado === "EXITO") {
						setAcumuladoDescansoMedico(response.data);
					}
				} catch (error) {
					console.error("Error al obtener acumulado DM:", error);
				}
			} else {
				setAcumuladoDescansoMedico(null);
				setSimulacionDescansoMedico(null);
			}
		};
		cargarAcumuladoDM();
	}, [tipoAusencia]);

	const onEliminarHistorialCambioGrupo = (idx, solicitudId) => {
		setHistorialCambioGrupo((prev) => prev.filter((_, i) => i !== idx));
		if (solicitudId) setIdsParaEliminar((prev) => [...prev, solicitudId]);
	};

	const onChangeColaboradorCambioGrupo = async (colaboradorDni) => {
		if (!colaboradorDni || tipoAusencia?.descripcion?.toLowerCase() !== "cambio de grupo") {
			setHistorialCambioGrupo([]);
			return;
		}
		setLoadingHistorial(true);
		try {
			const response = await SolicitudAusenciaService.listarHistorialCambioGrupo(colaboradorDni);
			setHistorialCambioGrupo(response.estado === "EXITO" ? (response.data || []) : []);
		} catch {
			setHistorialCambioGrupo([]);
		}
		setLoadingHistorial(false);
	};

	const onSearchColaboradores = async (value) => {
			if (value === "") {
				setColaboradores([]);
				return;
			}
			const respuesta = await ColaboradorService.listarPorNombreCompletoODniYAprobador({
				filtro: value.trim(),
			});
			setColaboradores(respuesta.colaboradores);
	};
	
	return (
		<>
			<Modal
				title={(isSDF || isSDFEnergia) ? "Registrar Solicitud Movimiento" : "Registrar Solicitud Ausencia"}
				bodyStyle={{ overflowY: "auto", minHeight: "calc(100vh - 220px)", maxHeight: "calc(100vh - 220px)" }}
				width={600}
				centered
				visible={visibleModal}
				onCancel={() => {
					setVisibleModal(false);
					form.resetFields();
					limpiarTipoAusencia();
					setIdsParaEliminar([]);
					setAcumuladoDescansoMedico(null);
					setSimulacionDescansoMedico(null);
					setEsDescansoMedico(false);
				}}
				onOk={() => form.submit()}
				okText={"Solicitar"}
				okButtonProps={{
					disabled: vacacionesSimuladasError ? true : false,
				}}
			>
				{(isMaccaferriDePeru || isMaccaferriConstruction) && !existeClave && (
					<div style={{ display: "flex", flexDirection: "column", paddingBottom: "10px" }}>
						<span style={{ fontSize: "20px", fontWeight: "bold", color: "#108ee9", textAlign: "left", paddingLeft: "10px" }}>
							<Button type="link" onClick={abrirCrearClaveModal} style={{ padding: "0 5 5" }}>
								Crea tu clave para firmar tus documentos.
							</Button>
						</span>
						<span style={{ fontSize: "13px", textAlign: "center" }}></span>
					</div>
				)}
				{" "}
				{tipoAusencia?.contabilizarDiasVacaciones && (
					<div style={{ display: "flex", flexDirection: "column" }}>
						<span style={{ fontSize: "20px", fontWeight: "bold", color: "#108ee9", textAlign: "center" }}>
							{tipoAusencia?.ocultarDiasTruncos
								? detalleVacacionesColaborador?.vacacionesDisponiblesConDiasTruncos + " DÍAS"
								: detalleVacacionesColaborador?.vacacionesDisponibles + " DÍAS"}
							{/* {detalleVacacionesColaborador?.vacacionesDisponibles} DÍAS */}
						</span>
						<span style={{ fontSize: "13px", textAlign: "center" }}>disponibles</span>
					</div>
				)}
				<Form form={form} layout={"vertical"} onFinish={onClickBtnSolicitar} style={{ padding: "0px 5%" }}>
					<AvisoBloqueoMovimientos fechaLimite={fechaLimite} />
					<Form.Item
						label={(isSDF || isSDFEnergia) ? "Tipo Movimiento" : isManuelita ? "Tipo de Solicitud" : "Tipo Ausencia"}
						name={"tipoAusenciaId"}
						labelAlign="left"
						rules={[{ required: true, message: "Seleccione el tipo" }]}
					>
						<Select style={{ width: "100%" }} onChange={onChangeTipoAusencia}>
							{tiposAusencia !== undefined &&
								tiposAusencia.map((tipo) => {
									return (
										<Select.Option key={tipo.id} value={tipo.id}>
											{tipo.descripcion}
										</Select.Option>
									);
								})}
						</Select>
					</Form.Item>

					{tipoAusencia?.controles &&
						tipoAusencia.controles.map((info) => {
							return <Control key={info.key} info={info} />;
						})}

					{tipoAusencia?.archivos &&
						tipoAusencia.archivos.map((info) => {
							return <Archivo key={info.key} info={info} />;
						})}

					{(tipoAusencia?.descripcion === "Bonificación por reemplazo" || tipoAusencia?.descripcion?.toLowerCase() === "cambio de grupo") && (
						<Form.Item
							label="Colaborador"
							name="colaborador"
							rules={[{ required: true, message: "Ingrese al colaborador" }]}
						>
							<Select
								style={{ width: "100%" }}
								allowClear
								showSearch
								placeholder="Ingrese el nombre del colaborador"
								onSearch={onSearchColaboradores}
								onChange={tipoAusencia?.descripcion?.toLowerCase() === "cambio de grupo" ? onChangeColaboradorCambioGrupo : undefined}
								filterOption={(input, option) =>
									option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
								}
							>
								{colaboradores !== undefined &&
									colaboradores?.map((colaborador) => (
										<Select.Option
											key={colaborador.numeroDocumentoIdentidad}
											value={colaborador.numeroDocumentoIdentidad}
										>
											{colaborador.nombreCompleto}
										</Select.Option>
									))}
							</Select>
						</Form.Item>
					)}

					{esDesktop && !ocultarFechasSolicitadas && !tipoAusencia?.solicitarUnaFecha && tipoAusencia?.descripcion?.toLowerCase() !== "cambio de grupo" && (
						<Form.Item
							label={
								<div>
									<CalendarOutlined /> Fechas Solicitadas
								</div>
							}
							name="fechasSolicitud"
							labelAlign="left"
							rules={[{ required: true, message: "Ingrese la fecha" }]}
							extra={<FechasSolicitadasExtra />}
							style={{ marginBottom: "0px" }}
						>
							<RangePicker
								allowClear={true}
								format={tipoAusencia?.contabilizarHoras ? "DD/MM/YYYY hh:mm a" : "DD/MM/YYYY"}
								//format="DD/MM/YYYY HH:mm:ss"
								showTime={tipoAusencia?.contabilizarHoras ? true : false}
								disabledDate={deshabilitarFechaInicio}
								onChange={onChangeRangePicker}
								style={{ width: "100%" }}
							/>
						</Form.Item>
					)}

					{esMovil && !ocultarFechasSolicitadas && !tipoAusencia?.solicitarUnaFecha && tipoAusencia?.descripcion?.toLowerCase() !== "cambio de grupo" && (
						<React.Fragment>
							<Form.Item
								label={
									<div>
										<CalendarOutlined /> Fecha Inicio
									</div>
								}
								name="fechaSolicitudInicio"
								labelAlign="left"
								rules={[{ required: true, message: "Ingrese la la fecha inicio" }]}
							>
								<DatePicker
									allowClear={true}
									disabledDate={deshabilitarFechaInicio}
									onChange={onChangeDatePickerFechaInicio}
									//format={"DD/MM/YYYY"}
									format={tipoAusencia?.contabilizarHoras ? "DD/MM/YYYY hh:mm a" : "DD/MM/YYYY"}
									showTime={tipoAusencia?.contabilizarHoras ? true : false}
									style={{ width: "100%" }}
								/>
							</Form.Item>

							<Form.Item
								label={
									<div>
										<CalendarOutlined /> Fecha Fin
									</div>
								}
								name="fechaSolicitudFin"
								labelAlign="left"
								rules={[{ required: true, message: "Ingrese la la fecha fin" }]}
								extra={<FechasSolicitadasExtra />}
							>
								<DatePicker
									allowClear={true}
									onChange={onChangeDatePickerFechaFin}
									//format={"DD/MM/YYYY"}
									format={tipoAusencia?.contabilizarHoras ? "DD/MM/YYYY hh:mm a" : "DD/MM/YYYY"}
									showTime={tipoAusencia?.contabilizarHoras ? true : false}
									disabledDate={deshabilitarFechasSolicitudFin}
									style={{ width: "100%" }}
								/>
							</Form.Item>
						</React.Fragment>
					)}

					{tipoAusencia?.solicitarUnaFecha && (
						<Form.Item
							label="Fecha Efectiva"
							name="fechaEfectiva"
							rules={[
								{
									required: true,
									message: "Ingrese la fecha",
								},
							]}
						>
							<DatePicker style={{ width: "100%" }}
								allowClear={true}
								disabledDate={deshabilitarFechaInicio}
								format={tipoAusencia?.contabilizarHoras ? "DD/MM/YYYY hh:mm a" : "DD/MM/YYYY"}
								showTime={tipoAusencia?.contabilizarHoras ? true : false}
							/>

						</Form.Item>
					)}
					{(isSDF || isSDFEnergia) && esDescansoMedico && acumuladoDescansoMedico && (
						<div style={{
							background: "#f0f7ff",
							border: "1px solid #91caff",
							borderRadius: "8px",
							padding: "12px 16px",
							marginTop: "12px",
							marginBottom: "4px",
						}}>
							<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
								<span style={{ fontSize: "12px", color: "#595959" }}>Descansos médicos acumulados</span>
								<span style={{ fontSize: "20px", fontWeight: "bold", color: "#1677ff", lineHeight: 1 }}>
									{acumuladoDescansoMedico.diasAcumulados} <span style={{ fontSize: "13px" }}>días</span>
								</span>
							</div>

							<div style={{ background: "#d9e8ff", borderRadius: "4px", height: "6px", marginBottom: "4px", overflow: "hidden" }}>
								<div style={{
									background: Number(acumuladoDescansoMedico.diasAcumulados) >= 20 ? "#fa8c16" : "#1677ff",
									width: `${Math.min((Number(acumuladoDescansoMedico.diasAcumulados) / 20) * 100, 100)}%`,
									height: "100%",
									borderRadius: "4px",
								}} />
							</div>
							<div style={{ textAlign: "right", fontSize: "10px", color: "#8c8c8c", marginBottom: "10px" }}>
								límite de subsidio: 20 días
							</div>

							{simulacionDescansoMedico && simulacionDescansoMedico.diasSubsidiados > 0 && (
								<div style={{ fontSize: "12px", color: "#d46b08", marginBottom: "8px" }}>
									<strong>Aviso:</strong> Sus descansos médicos acumulados superan los 20 días; los días posteriores serán gestionados como subsidio.
								</div>
							)}

							{simulacionDescansoMedico && simulacionDescansoMedico.diasSolicitados > 0 && (
								<div style={{ display: "flex", gap: "8px" }}>
									<div style={{
										flex: 1, background: "#f6ffed", border: "1px solid #b7eb8f",
										borderRadius: "6px", padding: "8px 4px", textAlign: "center",
									}}>
										<div style={{ fontSize: "20px", fontWeight: "bold", color: "#52c41a", lineHeight: 1.2 }}>
											{simulacionDescansoMedico.diasSolicitados}
										</div>
										<div style={{ fontSize: "11px", color: "#595959", marginTop: "2px" }}>
											Total días<br />solicitados
										</div>
									</div>
									{simulacionDescansoMedico.diasSubsidiados > 0 && (
										<div style={{
											flex: 1, background: "#fff7e6", border: "1px solid #ffd591",
											borderRadius: "6px", padding: "8px 4px", textAlign: "center",
										}}>
											<div style={{ fontSize: "20px", fontWeight: "bold", color: "#fa8c16", lineHeight: 1.2 }}>
												{simulacionDescansoMedico.diasSubsidiados}
											</div>
											<div style={{ fontSize: "11px", color: "#595959", marginTop: "2px" }}>
												día(s) serán gestionados<br />como subsidio
											</div>
										</div>
									)}
								</div>
							)}
						</div>
					)}

					{((isSDF || isManuelita || isDemo || isSDFEnergia) && contabilizaHoras) && (
						<Form.Item name="especificarHora" valuePropName="checked">
							<Checkbox onChange={handleEspecificarHoraChange}>
								Especificar hora
							</Checkbox>
						</Form.Item>
					)}
					{tipoAusencia?.descripcion?.toLowerCase() === "cambio de grupo" && (
						<Form.Item label="Cambio de Grupo" style={{ marginBottom: 8 }}>
							{/* Cabecera */}
							<div style={{ display: "flex", marginBottom: 0 }}>
								<div style={{
									flex: 1, background: "#217346", color: "#fff",
									fontWeight: "bold", textAlign: "center",
									padding: "4px 0", fontSize: 13,
									border: "1px solid #217346"
								}}>
									Fecha
								</div>
								<div style={{
									flex: 1, background: "#217346", color: "#fff",
									fontWeight: "bold", textAlign: "center",
									padding: "4px 0", fontSize: 13,
									border: "1px solid #217346", borderLeft: "none"
								}}>
									Grupo
								</div>
								<div style={{
									width: 36, background: "#217346",
									border: "1px solid #217346", borderLeft: "none"
								}} />
							</div>
							{/* Filas históricas (con opción de eliminar) */}
							{loadingHistorial ? (
								<div style={{ textAlign: "center", padding: "6px 0", fontSize: 12, color: "#888" }}>
									Cargando historial...
								</div>
							) : (
								historialCambioGrupo.map((item, idx) => (
									<div key={idx} style={{ display: "flex", background: "#f5f5f5", alignItems: "center" }}>
										<div style={{
											flex: 1, padding: "5px 8px", fontSize: 13,
											border: "1px solid #e0e0e0", borderTop: "none", color: "#595959"
										}}>
											{item.fecha ? moment(item.fecha).format("DD/MM/YYYY") : ""}
										</div>
										<div style={{
											flex: 1, padding: "5px 8px", fontSize: 13,
											border: "1px solid #e0e0e0", borderTop: "none", borderLeft: "none", color: "#595959"
										}}>
											{item.grupo}
										</div>
										<div style={{
											width: 36, display: "flex", justifyContent: "center", alignItems: "center",
											border: "1px solid #e0e0e0", borderTop: "none", borderLeft: "none",
											padding: "5px 0"
										}}>
											<DeleteOutlined
												style={{ color: "#ff4d4f", cursor: "pointer", fontSize: 14 }}
												onClick={() => onEliminarHistorialCambioGrupo(idx, item.solicitudId)}
											/>
										</div>
									</div>
								))
							)}
							{/* Nueva fila editable (única) */}
							<div style={{ display: "flex" }}>
								<Form.Item
									name={["informacionAdicional", "cambioGrupo", 0, "fecha"]}
									rules={[{ required: true, message: "" }]}
									style={{ flex: 1, marginBottom: 0 }}
								>
									<DatePicker
										format="DD/MM/YYYY"
										style={{ width: "100%", borderRadius: 0 }}
										placeholder="dd/mm/aaaa"
										disabledDate={deshabilitarFechaBloqueada}
									/>
								</Form.Item>
								<Form.Item
									name={["informacionAdicional", "cambioGrupo", 0, "grupo"]}
									rules={[{ required: true, message: "" }]}
									style={{ flex: 1, marginBottom: 0 }}
								>
									<Select placeholder="Grupo" style={{ width: "100%", borderRadius: 0 }}>
										{(isSDFEnergia
											? ["G1","G2","G3","G4","G5","G6","G7","G8","G9","G10","G11","G12","G13","G14","G15","G16","N","P","P1","P2","P3","P4","P5"]
											: ["A","B","C","D","E","F","G","G8","G9","H","I","II","III","M","N","P","R","S","T","X","Y"]
										).map((g) => (
											<Select.Option key={g} value={g}>{g}</Select.Option>
										))}
									</Select>
								</Form.Item>
							</div>
						</Form.Item>
					)}

					<Form.Item
						label={isMaccaferriConstruction || isMaccaferriDePeru ? "Empleado designado" : "Comentario"}
						name="comentario"
						labelAlign="left"
					>
						<TextArea autoSize={{ minRows: 2, maxRows: 5 }} showCount maxLength={250} />
					</Form.Item>

					{tipoAusencia?.descripcion !== "Bonificación por reemplazo" && tipoAusencia?.descripcion?.toLowerCase() !== "cambio de grupo" && (
						<Form.Item
							label="Aprobador"
							name="aprobador"
						// initialValue={jefeInmediato?.nombreCompleto}
						>
							<Input readOnly />
						</Form.Item>
					)}
				</Form>

			</Modal>

			<Modal
				title="Crear Clave"
				open={visibleCrearClaveModal}
				onCancel={cerrarCrearClaveModal}
				footer={null}
			>
				<Form
					form={formularioCambiarClave}
					labelCol={{
						span: 12,
					}}
					wrapperCol={{
						span: 12,
					}}
					layout="vertical"
					size="default"
					onFinish={handleOnFinish}
				>
					<FormItem
						label="Clave"
						name="clave"
						rules={[
							{
								required: true,
								message: "Ingrese su clave",
							},
						]}
					>
						<Input.Password />
					</FormItem>
					<FormItem
						label="Repetir Clave"
						name="claveR"
						dependencies={["clave"]}
						hasFeedback
						rules={[
							{
								required: true,
								message: "Ingrese nuevamente su clave",
							},
							({ getFieldValue }) => ({
								validator(rule, value) {
									if (
										!value ||
										getFieldValue("clave") === value
									) {
										return Promise.resolve();
									}

									return Promise.reject(
										"Las claves deben ser iguales!"
									);
								},
							}),
						]}
					>
						<Input.Password />
					</FormItem>
					<Row justify="center">
						<Space>
							<Col span={20}>
								<Button
									type="primary"
									icon={<CheckOutlined />}
									htmlType="submit"
									loading={loadingModalClave}
								>
									Guardar
								</Button>
							</Col>
							<Col>
								<Button
									type="default"
									onClick={cerrarCrearClaveModal}
								>
									Cancelar
								</Button>
							</Col>
						</Space>
					</Row>
				</Form>
			</Modal>
		</>
	);
};

export default ModalCrearSolicitudAusencia;
